export default function () {
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/computed.js